<template>
    <div class="attendance-filter">
        <Card dis-hover>
            <Row type="flex" justify="space-between">
                <Col :xs="2" :sm="4" :md="6" :lg="10" class="d-flex-center">
                    <Card class="page-title" dis-hover :bordered="false"> Attendance Logs </Card>
                </Col>
                <Col :xs="2" :sm="2" :md="3" :lg="4" class="d-flex-center">
                    <Select
                        v-model="selectedStatus"
                        :value="$route.query.status"
                        filterable
                        clearable
                        placeholder="Filter by"
                        @on-change="handleStatusChanged"
                    >
                        <Option v-for="item in filterStatus" :key="item.value" :value="item.value">
                            {{ item.name }}
                        </Option>
                    </Select>
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import Bugsnag from '@bugsnag/js';
// import moment from 'moment';
export default {
    data() {
        return {
            selectedStatus: this.$route.query.status,
        };
    },
    created() {
        if (this.$route.query.status) {
            this.$emit('status-changed', this.selectedStatus);
        }
    },
    methods: {
        handleStatusChanged(stats) {
            this.$emit('status-changed', stats);
            try {
                this.$router.replace({ query: null }).catch(() => {});
            } catch (e) {
                Bugsnag.notify(e);
            }
        },
    },
};
</script>
<style lang="scss">
@media screen and (max-width: 767px) {
    .attendance-filter {
        .ivu-row {
            display: block;

            .ivu-col {
                max-width: 100%;
            }
            .ivu-col-span-xs-2 {
                margin: 5px 0;
            }
            .filter-btn button {
                width: 100%;
            }
        }
    }
}
</style>
